import axioApi, { setHeader } from 'api/root.api';

export const otherModel = async (body, projectId)=>{
    const urlEnd = `/editor/project/v1/${projectId}/model/create`;
    // setHeader('Access-Control-Allow-Origin', '*');
    setHeader('Content-Type', 'application/json');
    const response = await axioApi.post(urlEnd, body);
    const result = response.data;
    return result;
};